export const nextButtonStyle =
  { border: '5px solid #57587F', backgroundColor: 'transparent' }